module.exports = "/_next/static/images/Mihaela_Poiata-c5a66858699850f929318780e9470244.webp";